import { render } from "./imagesList.vue?vue&type=template&id=77b5252c&scoped=true"
import script from "./imagesList.vue?vue&type=script&lang=js"
export * from "./imagesList.vue?vue&type=script&lang=js"

import "./imagesList.vue?vue&type=style&index=0&id=77b5252c&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b5252c"]])

export default __exports__